export default __webpack_public_path__ + "static/media/logo.3da26b9e.svg";